import commonUtil from '../../../utils/commonUtil';

export const BFF_SEARCHED_PRODUCT_LOAD = 'BFF_SEARCHED_PRODUCT_LOAD';
export const BFF_SEARCHED_PRODUCT_LOAD_SUCCESS = 'BFF_SEARCHED_PRODUCT_LOAD_SUCCESS';
export const BFF_SEARCHED_PRODUCT_LOAD_FAIL = 'BFF_SEARCHED_PRODUCT_LOAD_FAIL';

export function loadSearchedDetailOfPoduct(globalState) {
  return globalState.BFFSearchedPoductData && globalState.BFFSearchedPoductData.loaded;
}

export function BFFSearchedDetailOfPoduct(searchTerm, newPayload) {
  const userEnteredData = {};
  userEnteredData.searchTerm = searchTerm;
  userEnteredData.brandName = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = 'WEB';
  userEnteredData.newPayload = newPayload;  //  Changes for GR Serach Facade
  return {
    types: [BFF_SEARCHED_PRODUCT_LOAD, BFF_SEARCHED_PRODUCT_LOAD_SUCCESS, BFF_SEARCHED_PRODUCT_LOAD_FAIL],
    promise: client => client.post('/api/search/bffTypeAhead', {
      data: (userEnteredData),
    }),
  };
}
